import { i18n } from './../../../plugins/i18n' 
export default function getStore(vue) {
  return {
    state: {
      user: {
        isAuthenticated: false,
        authData: {},
        role: null,
        errorMessage: ''
      }
    },
    mutations: {
      SET_USER(state, payload) {
        const userPhoto = window.sessionStorage.getItem('userPhoto2')
        if (userPhoto && payload?.userPhoto === userPhoto) {
          window.sessionStorage.removeItem('userPhoto2')
        }
        state.user.authData = payload
        state.user.isAuthenticated = !!payload
      }, 
      SET_USER_ROLE(state, role) {
        state.user.role = role
      }

    },
    actions: {
      async SIGNIN({ commit }, { email, password, keepSigned }) {
        vue.$authEventEmiter.callStartProcessing() // onStartProcessing
        vue.$authEventEmiter.callBeforeSignIn() // onBeforeSignIn
        
        try {
          const result = await vue.$authCore.auth.login(email, password, keepSigned)
          if (result.success) {
            await vue.$lifeCycleCore.CallAfterSignInHook({ modelId: vue.$lifeCycleCore.store.getters.appModel.$ID })
            await vue.$authCore._getAdditionalUserData()
            await vue.$authEventEmiter.callAfterSignIn(vue) // callAfterSignIn
            commit('SET_USER', vue.$authCore.auth.getUserData())
            vue.$authCore.store.state.auth.user.errorMessage = ''
            vue.$authCore.store.state.auth.user.NeedChangePassword = result.NeedChangePassword
          } else {
            vue.$authEventEmiter.callSignInError(result) // onSignInError
            if (result.errorMessage) {
              vue.$authCore.store.state.auth.user.errorMessage = result.errorMessage
            }
          }
        } catch (e) {
          vue.$authEventEmiter.callSignInError(e) //onSignInError
        } finally {
          vue.$authEventEmiter.callEndProcessing() //onEndProcessing
        }
      },
      
      async GETAUTHGUID () {
        vue.$authEventEmiter.callStartProcessing() // onStartProcessing
        try {
          return await vue.$authCore.auth.getAuthGuid()
        } catch (e) {
          vue.$authEventEmiter.callSignInError(e) //onSignInError
        } finally {
          vue.$authEventEmiter.callEndProcessing() //onEndProcessing
        }
      },
      
      async SIGNIN_BY_DIGITAL_SIGNATURE ({ commit }, sign) {
        let response = { success: false, errorMessage: ''}
        vue.$authEventEmiter.callStartProcessing() // onStartProcessing
        try {
          response = await vue.$authCore.auth.loginByDigitalSignature(sign)
          if (!response.success) {
            vue.$authEventEmiter.callSignInError(response)
          }
        } catch (e) {
          vue.$authEventEmiter.callSignInError(e) //onSignInError
        } finally {
          vue.$authEventEmiter.callEndProcessing() //onEndProcessing
        }
        await vue.$authCore._getAdditionalUserData()
        await vue.$authEventEmiter.callAfterSignIn(vue) // callAfterSignIn
        commit('SET_USER', vue.$authCore.auth.getUserData())
        return response
      },
      

      async SIGNIN_SEND_SMS_CODE(context, { phone }) {
        let response = { success: false, errorMessage: ''}
        vue.$authEventEmiter.callStartProcessing() // onStartProcessing
        try {
          response = await vue.$authCore.auth.loginBySMS(phone)
          if (!response.success) {
            vue.$authEventEmiter.callSignInError(response)
          }
        } catch (e) {
          vue.$authEventEmiter.callSignInError(e) //onSignInError
        } finally {
          vue.$authEventEmiter.callEndProcessing() //onEndProcessing
        }
        return response
      },

      async SIGNIN_SEND_ONE_TIME_PASS({ commit }, { pass }) {
        vue.$authEventEmiter.callStartProcessing() // onStartProcessing
        vue.$authEventEmiter.callBeforeSignIn() // onBeforeSignIn

        try {
          const response = await vue.$authCore.auth.enterOneTimeSMSPassword(pass)
          if (response.success) {
            await vue.$lifeCycleCore.CallAfterSignInHook({ modelId: vue.$lifeCycleCore.store.getters.appModel.$ID })
            await vue.$authCore._getAdditionalUserData()
            await vue.$authEventEmiter.callAfterSignIn(vue) // callAfterSignIn
            commit('SET_USER', vue.$authCore.auth.getUserData())
          } else {
            vue.$authEventEmiter.callSignInError(response) // onSignInError
          }
        } catch (e) {
          vue.$authEventEmiter.callSignInError(e) //onSignInError
        } finally {
          vue.$authEventEmiter.callEndProcessing() //onEndProcessing
        }
      },

      async SIGN_IN_BY_CODE({ commit }, { code }) {
        vue.$authEventEmiter.callStartProcessing() // onStartProcessing
        vue.$authEventEmiter.callBeforeSignIn() // onBeforeSignIn
        
        try {
          const result = await vue.$authCore.auth.loginByCode(code)
          if (result.success) {
            await vue.$lifeCycleCore.CallAfterSignInHook({ modelId: vue.$lifeCycleCore.store.getters.appModel.$ID })
            await vue.$authCore._getAdditionalUserData()
            await vue.$authEventEmiter.callAfterSignIn(vue) // callAfterSignIn
            commit('SET_USER', vue.$authCore.auth.getUserData())
          } else {
            vue.$authEventEmiter.callSignInError(result) // onSignInError
          }
        } catch (e) {
          vue.$authEventEmiter.callSignInError(e) //onSignInError
        } finally {
          vue.$authEventEmiter.callEndProcessing() //onEndProcessing
        }
      },

      SIGNOUT({ commit }) {
        vue.$authCore.auth.logout({
          returnUrl: window.location.pathname,
          skipSigninSilent: vue.$lifeCycleCore.store.getters.appModel.ProjectSecurity.OidcEnabled,
          lang: i18n.locale
        }).then(() => {
          commit('SET_USER', null)
          window.sessionStorage.removeItem('userName')
          window.sessionStorage.removeItem('userPhoto')
          window.sessionStorage.removeItem('userPhoto2')
          window.sessionStorage.removeItem('delegateUserId')
          vue.$authEventEmiter.callSignOut() // onSignOut
          // eslint-disable-next-line no-console
        }).catch(e => console.warn('[LOGOUT]', e.message))
      },
      // вызывается только из роутера
      async UPDATE_USER_DATA({ commit, state }) {
        if (state.user.isAuthenticated) {
          return state.user.isAuthenticated
        }

        vue.$authEventEmiter.callStartProcessing() //onStartProcessing
        const token = await vue.$authCore.auth.getToken()
        if (token) {
          await vue.$lifeCycleCore.CallAfterSignInHook({ modelId: vue.$lifeCycleCore.store.getters.appModel.$ID })
          await vue.$authCore._getAdditionalUserData()
          await vue.$authEventEmiter.callAfterSignIn(vue) // callAfterSignIn
          commit('SET_USER', vue.$authCore.auth.getUserData())
        }
        vue.$authEventEmiter.callEndProcessing() //onEndProcessing
      }
    },
    getters: {
      userRole(state) {
        return state.user.role
      },
      userLogin(state) {
        return state.user.authData?.login
      },
      isAuthenticated(state) {
        return state.user.isAuthenticated
      }
    }

  }
}